<script setup>
import { defineProps, computed } from "vue";
import CardLoteArrematado from "./CardLoteArrematado";
import CardFatura from "./CardFatura";
import CardAnalise from "@/Pages/Arremates/CardAnalise.vue";

const props = defineProps({
    faturas: Object,
    semFatura: Boolean,
});

const arrematesSemFaturas = computed(() => {
    const fats = {};

    if (!props.faturas || props.faturas?.length === 0) {
        return [];
    }

    props.faturas?.forEach((lote) => {
        const arremateFatura = lote.lances[0]?.arremates[0]?.arrematesfatura[0];
        if (!arremateFatura) {
            if (!fats[-1]) {
                fats[-1] = {
                    id: null,
                    dados: null,
                    lotes: [],
                };
            }
            fats[-1].lotes.push(lote);
        }
    });

    return fats;
});
</script>

<template>
    <div class="flex row full-width q-pa-sm">
        <template v-if="semFatura === true">
            <card-analise
                :key="idx"
                :fatura="fatura"
                :sem-fatura="semFatura"
                v-for="(fatura, idx) in arrematesSemFaturas"
            >
                <card-lote-arrematado
                    :key="lote.id"
                    :index="index"
                    v-for="(lote, index) in fatura?.lotes || []"
                    :lote-init="lote"
                    :leilao-init="lote.leilao"
                    :mostrar-leilao="true"
                />
            </card-analise>
        </template>
        <template v-else>
            <card-fatura
                :key="idx"
                :fatura="fatura"
                v-for="(fatura, idx) in faturas"
            >
                <card-lote-arrematado
                    :key="arremate.id"
                    :index="index"
                    v-for="(arremate, index) in fatura?.arremates_fatura || []"
                    :arremate-fatura="arremate"
                    :lote-init="arremate?.arremate?.lance?.lote"
                    :leilao-init="arremate?.arremate?.lance?.lote?.leilao"
                    :mostrar-leilao="true"
                />
            </card-fatura>
        </template>
    </div>
</template>
